<template>
  <div class="buy_footer">
    <div class="price">
      总价：¥ <span>{{ price }}</span>
    </div>
    <div class="btn" :class="{disabled: disabled}" @click="handleClick">确定</div>
  </div>
</template>

<script>
export default {
  name: 'buy-footer',
  props: ['price', 'canSubmit'],
  computed: {
    disabled () {
      return !this.canSubmit
    }
  },
  created () {
  },
  methods: {
    handleClick () {
      if (!this.canSubmit) return false
      this.$emit('submit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  .buy_footer {
    max-width: 640px;
    height: rem(85);
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: rgba(255, 255, 255, 0.93);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price {
      width: 60%;
      height: rem(85);
      line-height: rem(85);
      box-sizing: border-box;
      padding-left: rem(30);
      background-color: rgba(20, 20, 20, 0.9);
      color: #fff;
      font-size: rem(28);
      text-align: left;
      span {
        color: #ff931b;
        font-weight: bold;
        font-size: rem(26);
      }
    }
    .btn {
      width: 40%;
      background: #ff9500;
      height: rem(85);
      line-height: rem(85);
      font-size: rem(26);
      color: #fff;
      &.disabled {
        background: #999;
      }
    }
  }
</style>
